declare global {
    interface NumberConstructor {
        /**
         * Ensures that a value is a valid number, returning a default value if not.
         * @param value The value to check.
         * @param defaultValue The default value to return if the check fails. Default is 0.
         * 
         * @returns The validated number or the default value.
         * ```typescript
         * Number.ensure("someValue", 10);// value will be 10 as "someValue" is not a number
         * Number.ensure(undefined, 15); // value will be 15 as undefined is not a number
         * Number.ensure(25); // value will be 25
         * ```
         */
        ensure(value: unknown, defaultValue?: number): number;
    }
}
Number.ensure = function (value: unknown, defaultValue: number = 0): number {
    if (typeof value === "number" && !isNaN(value)) {
        return value;
    }
    return defaultValue;
};
export default {};